export const cloneDeep = <T>(value: T): T => {
  return JSON.parse(JSON.stringify(value))
}

export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms)
  })
}
